import { permissions } from '@mpk/shared/domain';

/**
 * Supplier settings can be used
 */
enum SupplierTransactionSettingsPermissionsEnum {
  None = 0,

  /**
   * View suppliers settings.
   */
  ViewSupplierTransactionSettings = 1,
  /**
   * View and manage supplier settings.
   */
  ManageSupplierTransactionSettings = 2 | ViewSupplierTransactionSettings,
}

export const SupplierTransactionSettingsPermissions = permissions(SupplierTransactionSettingsPermissionsEnum, {
  featureId: 'SupplierTransactionSettings',
  featureDisplayName: 'Lieferanteneinstellungen',
  displayNames: {
    ViewSupplierTransactionSettings: 'Lieferanteneinstellungen anzeigen',
    ManageSupplierTransactionSettings: 'Lieferanteneinstellungen anzeigen und verwalten',
  },
});
